module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__imagery"
  }, [_c('div', {
    staticClass: "builder__imagery-base-layer"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.builder_base_photo_fID > 0 ? _vm.product.builder_base_photo_src : _vm.product.primary_photo_src,
      "alt": _vm.product.primary_photo_alt
    }
  })]), _vm._v(" "), _vm._l((_vm.imageryLayerSrcs), function(src) {
    return _c('div', {
      staticClass: "builder__imagery-option-layer"
    }, [_c('img', {
      attrs: {
        "src": src,
        "alt": ""
      }
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dab2106"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imagery.vue
// module id = 366
// module chunks = 0